export default "__VITE_ASSET__DXQYh_db__"